import { useState } from 'react';
import DexTradesMobile from '../../../components/DexTrades/mobile';
import Notifs from '../../../components/Notifications';
import TrendingMobile from '../../../components/Trending/mobile';
import { CurrentTickerCard } from '../../../molecules/TickerCard';
import Image from '../../../atoms/Image';
import Modal from '../../../components/Modal/index';
import ChartMobile from './Chart';
import FooterMobile from './Footer';
import HeaderMobile from './Header';
import Sidebar from './Sidebar';
import arrowLeft from '../images/arrowLeft.svg';
import Trading from '../../../components/Trading';
import SearchTable, {
  IMobileFilterProps,
} from '../../../components/SearchTable/SearchTable';
import FilterOptions from '../../../components/Modal/TickersModal/mobile/FilterOptions';
import TickerTableMobile from '../../../components/Modal/TickersModal/mobile/TickerTable';
import WhatchlistTableMobile from '../../../components/Watchlist/mobile/WatchListTable';
import TrendingTableMobile from '../../../components/Trending/mobile/TrendingTable/TrendingTable';
import MobileSort, {
  IMobileSortProps,
} from '../../../components/MobileSort/MobileSort';
import News from '../../../components/News/mobile';

import '../../../helpers/Viewport';

export enum MobileState {
  'Normal',
  'Watchlist',
  'Trading',
  'Trending',
  'Search',
  'Sidebar',
  'News',
}

export const PanelMobile = ({ title, onBack, children }: any) => (
  <div className='panel_mobile'>
    <div className='panel_mobile__header'>
      <div
        className='icon-arrow-left panel_mobile__header__back'
        onClick={() => onBack()}
      />
      <span>{title}</span>
    </div>
    <div className='panel_mobile__body'>{children}</div>
  </div>
);

const SearchPanel = ({ onBack }: { onBack(): void }) => {
  const renderTable = (
    search: string,
    onChildMount: (data: IMobileFilterProps) => void,
    onBack: () => void
  ) => (
    <TickerTableMobile
      inputSearch={search}
      onMount={onChildMount}
      onBack={onBack}
    />
  );

  const renderFilterOptions = (props: IMobileFilterProps) => (
    <FilterOptions {...props} />
  );

  return (
    <SearchTable
      tableTitle='Advanced search'
      filterTitle='Select markets'
      filterIcon='filter'
      renderChildren={renderTable}
      renderFilterOptions={renderFilterOptions}
      onBack={onBack}
    />
  );
};

const WatchlistPanel = ({ onBack }: { onBack(): void }) => {
  const renderTable = (
    search: string,
    onChildMount: (data: IMobileFilterProps) => void,
    onBack: () => void
  ) => (
    <WhatchlistTableMobile
      inputSearch={search}
      onMount={onChildMount}
      onBack={onBack}
    />
  );

  const renderFilterOptions = (props: IMobileSortProps) => (
    <MobileSort {...props} />
  );

  return (
    <SearchTable
      tableTitle='Watchlist'
      filterTitle='Sorting by'
      filterIcon='filter-alt'
      renderChildren={renderTable}
      renderFilterOptions={renderFilterOptions}
      onBack={onBack}
    />
  );
};

export const TrendingPanel = ({ onBack }: { onBack(): void }) => {
  const renderTable = (
    search: string,
    onChildMount: (data: IMobileFilterProps) => void,
    onBack: () => void
  ) => (
    <TrendingTableMobile
      inputSearch={search}
      onMount={onChildMount}
      onBack={onBack}
    />
  );

  const renderFilterOptions = (props: IMobileSortProps) => (
    <MobileSort {...props} />
  );

  return (
    <SearchTable
      tableTitle='Trending'
      filterTitle='Sorting by'
      filterIcon='filter-alt'
      renderChildren={renderTable}
      renderFilterOptions={renderFilterOptions}
      onBack={onBack}
    />
  );
};

const TradingPanel = ({ onBack }: any) => (
  <PanelMobile title='Trading' onBack={onBack}>
    <Trading />
  </PanelMobile>
);

const MobileBody = () => {
  const [state, setState] = useState<MobileState>(MobileState.Normal);
  const onBack = () => setState(MobileState.Normal);
  const onSidebar = () => setState(MobileState.Sidebar);
  const onSearch = () => setState(MobileState.Search);
  const onTrending = () => setState(MobileState.Trending);
  const onWatchlist = () => setState(MobileState.Watchlist);
  const onTrading = () => setState(MobileState.Trading);
  const onNews = () => setState(MobileState.News);

  const contentFn = () => {
    switch (state) {
      case MobileState.Sidebar:
        return (
          <Sidebar
            onBack={onBack}
            onTrending={onTrending}
            onWatchlist={onWatchlist}
            onTrading={onTrading}
          />
        );
      case MobileState.Watchlist:
        return <WatchlistPanel onBack={onBack} />;
      case MobileState.Trending:
        return <TrendingPanel onBack={onBack} />;
      case MobileState.Trading:
        return <TradingPanel onBack={onBack} />;
      case MobileState.Search:
        return <SearchPanel onBack={onBack} />;
      case MobileState.News:
        return <News onBack={onBack} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className='content_mobile'>
        <HeaderMobile
          onToggleSidebar={onSidebar}
          onToggleSearch={onSearch}
          onToggleNews={onNews}
        />
        {contentFn()}
        <TrendingMobile />
        <CurrentTickerCard />
        <ChartMobile />
        <DexTradesMobile />
      </div>
      <FooterMobile selected={state} onChange={setState} />
      <Modal />
      <Notifs />
    </>
  );
};

export default MobileBody;
